import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { WebNavbarComponent } from '../../web-components/web-navbar/web-navbar.component';
import { WebFooterComponent } from '../../web-components/web-footer/web-footer.component';

@Component({
    standalone: true,
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.css'],
    imports: [WebNavbarComponent, WebFooterComponent]
})
export class PricingComponent {
  constructor(private router: Router) {} 

  redirectTo(page){
    this.router.navigate([page]);
  }
}
